import React from 'react';

import { LargeCenteredContainer } from '@eika/engine-view';

import VisaExchangeCalculator from '@components/visa-exchange-calculator/VisaExchangeCalculator';

const VisaFxSimpleCalculatorPageV3 = () => (
    <LargeCenteredContainer>
        <VisaExchangeCalculator />
    </LargeCenteredContainer>
);

export default VisaFxSimpleCalculatorPageV3;
